/* global Homie */
/* global Vue */
require('../../config/init');

import LoaderPopup from '../../shared/libs/LoaderPopup';
import es from 'vee-validate/dist/locale/es';
import VueSweetAlert from 'vue-sweetalert';
import VeeValidate, {Validator} from 'vee-validate';
import Validations from '../../shared/locales/Validations';
import hiddenFooter from '../../shared/mixins/hidden_footer';
import googleTagManager from '../../shared/mixins/google_tag_manager';
import axios from 'axios';

Vue.use(VueSweetAlert);
Validator.addLocale(es);
Vue.use(VeeValidate, {
  locale: 'es',
  dictionary: Validations,
  events: 'blur'
});

export default {
  template: '#auth-register',
  props: ['userRole'],
  data() {
    return {
      mobile_phone_backup: null,
      country_code: 52,
      show_contry_codes: false,
      user: {
        name: '',
        last_name: '',
        second_last_name: '',
        mobile_phone: '',
        password: '',
        password_confirmation: '',
        terms_and_conditions: true,
        is_subscribed: true
      },
      from_axios: true,
      error: false,
      role: this.userRole
    }
  },
  computed: {},
  mounted() {
    $('html, body').animate({scrollTop: 0}, 250);
  },
  methods: {
    showCountryCodes() {
      this.show_contry_codes = true;
    },
    hideCountryCodes() {
      this.show_contry_codes = false;
    },
    getRegistered(e) {
      this.$validator.validateAll().then((formValid) => {
        if (formValid) {
          this.mobile_phone_backup = this.user.mobile_phone;
          this.user.mobile_phone = `+${this.country_code}${this.user.mobile_phone}`;
          this.submit(e);
        } else {
          Homie.Handlers.LayoutHandler.showFlashMessage('Hay errores en el formulario. Por favor verifica y vuelve a intentar', 'error');
        }
      }).catch(() => {
      });
    },
    submit(e) {
      googleTagManager.methods.triggerFromOnboarding(window.location.href);
      LoaderPopup.show();
      $('.js-submit-register').prop('disabled', true);
      axios.post(e.target.action, this.$data)
        .then(response => {
          window.location.href = response.data.redirect;
          $('.js-submit-register').prop('disabled', false);
        })
        .catch(error => {
          $('.js-submit-register').prop('disabled', false);
          this.user.mobile_phone = this.mobile_phone_backup;
          LoaderPopup.hide();
          this.error = error.response.data.message || 'Error en el registro';
          this.$swal({title: '', text: this.error, timer: 5000}).catch(this.$swal.noop);
        })
    }
  },
  mixins: [hiddenFooter, googleTagManager]
}